// This file is auto-generated by scripts/generate-revision.js
// Do not edit manually - changes will be overwritten on next build

export const REVISION = 'fee8608c0 (feature/EDUS-3304)';
export const VERSION = '0.16.12';
